import { environment as env } from './environment.default';
import merge from 'lodash-es/merge';

export const environment = merge(env, {
  environmentName: 'test',
  // plausible: 'test.altorney.com',
}) as typeof env;
